webpackJsonp([265],{

/***/ 1109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImgFlowConfigDetail_vue__ = __webpack_require__(2716);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_796abf8e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImgFlowConfigDetail_vue__ = __webpack_require__(4159);
function injectStyle (ssrContext) {
  __webpack_require__(4153)
  __webpack_require__(4155)
  this["$style"] = __webpack_require__(4157)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-796abf8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImgFlowConfigDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_796abf8e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImgFlowConfigDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {
      table: [{
        key: 'id',
        label: '流转ID',
        value: ''
      }, {
        key: 'name',
        label: '流转名称',
        value: ''
      }, {
        key: 'customer_id',
        label: '所属客户',
        value: ''
      }, {
        key: 'project_id',
        label: '所属项目',
        value: ''
      }, {
        key: 'batch_id',
        label: '所属批次',
        value: ''
      }, {
        key: 'step_template_id',
        label: '所属模板',
        value: ''
      }, {
        key: 'created_at',
        label: '添加日期',
        value: ''
      }, {
        key: 'updated_at',
        label: '更新日期',
        value: ''
      }]
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.id = this.$route.params.id;
    this.id > 0 && this.setDetailData(this.id);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('getImgFlowConfigDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this.table.forEach(function (obj) {
          if (data[obj.key]) {
            obj.value = data[obj.key];
          }
        });
      });
    }
  })
});

/***/ }),

/***/ 4153:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4154);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("e99e4f22", content, true, {});

/***/ }),

/***/ 4154:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImgFlowConfigDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4155:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4156);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f36e875a", content, true, {});

/***/ }),

/***/ 4156:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImgFlowConfigDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4157:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4158);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("83580436", content, true, {});

/***/ }),

/***/ 4158:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImgFlowConfigDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/img-flow-config/table"}},[_vm._v("图片流转配置列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-table',{staticClass:"margin b15",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","show-header":false}},[_c('el-table-column',{attrs:{"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.value))])]}}])})],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/img-flow-config/table"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/img-flow-config-detail.a7103737ceb908897ecb.js